import React from "react";
import { messages } from "../../../../../messages";
import "./Season.css";

export default function AddSeason({ mode, season, handleFormChange, closeModal, fromSubmitted }) {
    const error = messages;
    return <>
        <div className="modal addSeason-popup">
            <div className="modal-header">
                <h2>{mode === 'add' ? 'Add Season' : 'Edit Season'}</h2>
                <span className="close" onClick={() => closeModal(null)}>×</span>
            </div>
            <div className="modal-body">
                <div className="input-field">
                    <label>Season Title</label>
                    <input type="text" name="name" value={season} onChange={handleFormChange} />
                    {!(season || '').trim() && fromSubmitted && <span className="error">{error['season_title']}</span>}
                </div>
            </div>
        </div>
    </>
}